<template>
  <transition name="slide-fade">
    <div class="component-modal-success text-center">
      <img class="modal-success-product" src="@/assets/images/microba-insight-kit.png" />

      <div class="bodyText">
          <h2>{{title}}</h2>

          <p class="ml-3 mr-3">{{bodyText}}</p>
      </div>

      <div class="button">
        <button class="btn btn-primary" @click="$emit('close')">{{buttonText}}</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['bodyText', 'buttonText', 'title'],
  name: 'ModalSuccess'
}
</script>

<style scoped lang="scss">
.component-modal-success{
    i {
        font-size: 70px;
        text-align: center;
        display: block;
        color: #5CD69F;
        margin-bottom: 2rem;
    }
    .bodyText{
      margin-bottom: 2rem;
    }

    .btn{
        min-width: 130px;
    }

  .modal-success-product {
    max-width: 200px;
    margin-bottom: 1.5rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/models/components/ModalSuccess.vue